import { render } from "./inDebt.html?vue&type=template&id=6795aafc&scoped=true&ts=true&external"
import script from "./InDebt.vue?vue&type=script&lang=ts"
export * from "./InDebt.vue?vue&type=script&lang=ts"

import "./InDebt.vue?vue&type=style&index=0&id=6795aafc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6795aafc"]])

export default __exports__